import Vue from "vue";

export default {
	state: {
		companies: [],
		actualCompany: {},
		selectedCompanies: []
	},
	mutations: {
		setCompaniesOnState(state, companies) {
			state.companies = mapCompanies(companies);
		},
		setCompanyOnState(state, actualCompany) {
			state.actualCompany = mapCompany(actualCompany);
		},
		setSelectedCompaniesOnState(state, selectedCompanies) {
			state.selectedCompanies = selectedCompanies;
		}
	},
	actions: {
		getCompaniesByGroup() {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("companyByGroup")
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		getCompaniesByGroupAndIdInvite(_, idInvite) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("companyByGroupAndIdInvite/" + idInvite)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		getCompanies({ commit }) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("company")
					.then((response) => {
						commit("setCompaniesOnState", response.data.data);
						resolve(response);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getCompaniesByIdClient({ commit }, idClient) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get(`company/client/${idClient}`)
					.then((response) => {
						commit("setCompaniesOnState", response.data.data);
						resolve(response);
						this.state.loading = false;
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getCompany({ commit }, id) {
			this.state.loading = true;

			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("company/" + id)
					.then((response) => {
						this.state.loading = false;
						commit("setCompanyOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		deleteCompany(_, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.delete("company/" + id).then((response) => {
					this.state.loading = false;
					resolve(response);
				});
			}).catch(() => {
				this.state.loading = false;
			});
		},
		createCompany(_, company) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("company", company)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		editCompany(_, company) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				mapCompaniesToBack(company).then((mappedCompany) => {
					Vue.prototype.$http
						.put("company/" + mappedCompany.Id, mappedCompany)
						.then((response) => {
							this.state.loading = false;
							resolve(response);
						})
						.catch((error) => {
							this.state.loading = false;
							reject(error.response.data.error.message);
						});
				});
			});
		}
	},
	getters: {
		companies({ companies }) {
			return companies;
		},
		selectedCompanies({ selectedCompanies }) {
			return selectedCompanies;
		},
		company({ actualCompany }) {
			return actualCompany;
		}
	}
};

const mapCompany = (companyFromBack) => {
	let response = {
		idCompany: companyFromBack.idCompany,
		companyName: companyFromBack.companyName,
		corporationName: companyFromBack.corporationName,
		address: companyFromBack.address,
		complement: companyFromBack.complement,
		district: companyFromBack.district,
		city: companyFromBack.city,
		state: companyFromBack.state,
		zipCode: companyFromBack.zipCode,
		country: companyFromBack.country,
		cnpj: companyFromBack.cnpj,
		stateRegistration: companyFromBack.stateRegistration,
		number: companyFromBack.number,
		fax: companyFromBack.fax,
		contact: companyFromBack.contact,
		jobPosition: companyFromBack.jobPosition,
		site: companyFromBack.site,
		email: companyFromBack.email,
		codeERP: companyFromBack.codeERP,
		idCompanyGroup: companyFromBack.idCompanyGroup,
		activated: companyFromBack.activated
	};
	return response;
};

const mapCompaniesToBack = (companies) => {
	return new Promise((resolve) => {
		let retObject = {
			Id: companies.idCompany,
			CompanyName: companies.companyName,
			CorporationName: companies.corporationName,
			Address: companies.address,
			Complement: companies.complement,
			District: companies.district,
			City: companies.city,
			State: companies.state,
			ZipCode: companies.zipCode,
			Country: companies.country,
			CNPJ: companies.cnpj,
			StateRegistration: companies.stateRegistration,
			Number: companies.number,
			Fax: companies.fax,
			Contact: companies.contact,
			JobPosition: companies.jobPosition,
			Site: companies.site,
			Email: companies.email,
			CodeERP: companies.codeERP,
			IdCompanyGroup: companies.idCompanyGroup,
			Activated: companies.activated
		};
		resolve(retObject);
	});
};

const mapCompanies = (companiesFromBack) => {
	let response = [];

	companiesFromBack.forEach((company) => {
		response.push(company);
	});
	return response;
};
